import { styled } from "styled-components";
import Theme from '../../styles/Theme/Theme';
import { Button, Col, Flex, Row } from 'antd';
import { PageContent, PageHeader, PageSection } from '../../styles/global/Pages.styled';
import { Text } from '../Global/Atomics/Text';
import CustomIcon from '../Global/Icons/CustomIcon';
import { Widget } from '../Global/Atomics/Widget';
import { useLocation, useNavigate } from 'react-router';
import { Footer } from '../App/Footer';
import { useTranslation } from 'react-i18next';

export const MapRegister = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();
    // const { data: mapData, isLoading: mapDataIsLoading, refetch: refetchMapData } = useFetch(query.path.registryMap, 'mapRegister', {ids: state?.itemsIds});

    const map =
    {
        id: 'map',
        cols: 24,
        height: '603px',
        width: 'auto',
        background: 'white',
        title: 'Localização dos ativos',
        icon: 'Localization',
        description: null,
        tooltip: null,
        charts: null,
        map: {
            type: 'mapRegister',
            idQuery: 'MapRegister',
            itemsIds: state?.itemsIds,
        },
    }

    return (
        <>
            {/* <Header /> */}
            <PageContent $backgroundColor='neutral-1'>

                <PageHeader className="map">
                    <Flex gap='large' align="center" justify="space-between">
                        <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03' $marginBottom='s05'>{t('map')}</Text>
                        <Button shape="circle" onClick={() => navigate(-1)} icon={<CustomIcon icon={'ArrowLeft'} iconsize='sm' color='white' />} style={{ $backgroundColor: Theme.color['blue-4'] }} />
                    </Flex>
                </PageHeader>
                <PageSection>
                    <Row gutter={[32, 32]}>
                        <Col span={24}>
                            <Widget data={map} />
                            {/* <MapWrapper>
                                <RegisterMapComponent itemsIds={state?.itemsIds} idQuery='MapRegister' />
                            </MapWrapper> */}
                        </Col>
                    </Row>
                </PageSection>
            </PageContent>
            <Footer />
        </>

    )
}

const MapWrapper = styled.div`
    height: 197px;
`;
// export const map =
// {
//     id: 'map',
//     cols: 24,
//     height: '603px',
//     width: 'auto',
//     background: null,
//     title: 'Assets localization',
//     icon: 'Localization',
//     description: null,
//     tooltip: null,
//     charts: null,
//     map: 'mapPOIS',
// }